import { Action, createReducer, on } from '@ngrx/store';

import { User } from './model/user.model';
import { AuthenticationActions, AuthenticationApiActions } from './authentication.actions';
import { ErrorCode } from '../../models/error-code.model';

export const authenticationFeatureKey = 'authentication';

export interface State {
    isAuthenticated: boolean; // is a user authenticated?
    user: User | null; // if authenticated, there should be a user object
    signInError: ErrorCode | null;
    signUpError: ErrorCode | null;
    recoverPasswordError: ErrorCode | null;
}

export const initialState: State = {
    isAuthenticated: false,
    user: null,
    signInError: null,
    signUpError: null,
    recoverPasswordError: null
};

const authenticationReducer = createReducer(
    initialState,
    on(
        AuthenticationApiActions.signIn,
        (state): State => ({
            ...state,
            signInError: null
        })
    ),
    on(AuthenticationActions.signInSuccess, (state, { user }) => ({
        ...state,
        isAuthenticated: true,
        signInError: null,
        user
    })),
    on(AuthenticationActions.signInFailure, (state, { error }) => ({
        ...state,
        signInError: error
    })),
    on(AuthenticationActions.signUpSuccess, (state) => ({
        ...state
    })),
    on(AuthenticationActions.signUpFailure, (state) => ({
        ...state
    })),
    on(AuthenticationActions.recoverPassword, (state) => ({
        ...state,
        recoverPasswordError: null
    })),
    on(AuthenticationActions.recoverPasswordFailure, (state, { error }) => ({
        ...state,
        recoverPasswordError: error
    })),
    on(AuthenticationActions.signOutSuccess, (state) => ({
        ...state,
        isAuthenticated: false,
        signInError: null,
        signUpError: null,
        user: null
    })),
    on(AuthenticationActions.setUser, (state, { user }) => ({
        ...state,
        isAuthenticated: true,
        user
    })),
    on(AuthenticationActions.clearErrors, (state) => ({
        ...state,
        signInError: null,
        signUpError: null,
        recoverPasswordError: null
    })),
    on(AuthenticationActions.authenticationFailed, (state) => ({
        ...state,
        user: null,
        isAuthenticated: false
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return authenticationReducer(state, action);
}
